<template>
	<div class='route_container'>
		<div class="main_container px-5 py-5 mt-5">
			<div class="row">
				<!-- category sidebar -->
				<div class="col-lg-3 filter-column pr-lg-3 px-0">
					<ul id="filtersList" class="nav accordion d-flex flex-column flex-nowrap bg-gray-900 border border-green-lighter border-top-0 mt-3 box-shadow">
						<li class="nav-item py-3">
							<div class="d-flex row align-items-center justify-content-between m-0 px-2">
								<div class="categories-title d-flex row align-items-center col-11">
									<p class="h6 text-white mb-0 py-2">Roles</p>
								</div>
							</div>
							<router-link
								v-for='(category, $index) in categories'
								:key='"category-link-" + $index'
								class='threads_main__side_bar__menu_item'
								:to='`/${$store.state.meta.lang}/users/` + category.value'
							>
								<span
									class='threads_main__side_bar__menu_item__border'
								></span>
								<span
									class='threads_main__side_bar__menu_item__text'
								>{{category.name}}</span>
							</router-link>
						</li>
					</ul>
				</div>
				<div class="col-lg-9 pl-lg-3 px-0">
					<div class="border border-green-lighter mt-3 pb-0 px-3">
						<h2 class="border-bottom border-green-lighter my-3"> Users </h2>
						<div class="table">
							<div class="table__heading">
								<h6 class="table__column--width-fill">User</h6>
								<h6 class="table__column--width-small text-center">{{ $t('gifts_comments') }}</h6>
								<h6 class="table__column--width-small text-center">{{ $t('gifts_entries') }}</h6>
								<h6 class="table__column--width-small text-center">{{ $t('gifts_level') }}</h6>
								<h6 class="table__column--width-small text-center">{{ $t('gifts_registered') }}</h6>
								<h6 class="table__column--width-small text-center">{{ $t('gifts_online') }}</h6>
							</div>
							<div class="table__row-outer-wrap">
								<div class="table__row-inner-wrap" v-for="user in users" :key="user.id">
									<router-link 
										:to="`/${$store.state.meta.lang}/user`" 
										class="giveaway_image_avatar" 
										:style="user.avatar?{ 'background-image': 'url(' + user.avatar + ')' }:{ 'background-image': 'url(' + missed_avatar + ')' }"
									></router-link>
									<div class="table__column--width-fill">
										<a :href="`/${$store.state.meta.lang}/user/13r0wny`" class="table__column__heading">{{user.name}}</a>
									</div>
									<div class="table__column--width-small text-center"> {{user.comments}} </div>
									<div class="table__column--width-small text-center"> {{user.entries}} </div>
									<div class="table__column--width-small text-center"> {{user.level}} </div>
									<div class="table__column--width-small text-center">
										<span>{{user.registered | formatDate}}</span> {{ $t('gifts_ago') }}
									</div>
									<div class="table__column--width-small text-center">
										<span>{{user.last_online | formatDate}}</span> {{ $t('gifts_ago') }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import FancyInput from '../FancyInput'

	export default {
		name: 'users',
		components: {
			FancyInput
		},
		data () {
			return {
				choosed_color: "#00ff7f",
				choosed_back_color: "#00ff7f",
				categories: [
					{ "name": "All", "value": ""},
					{ "name": "Member", "value": "member"},
					{ "name": "Game Developer", "value": "game-developer"},
					{ "name": "Junior Moderator", "value": "junior-moderator"},
					{ "name": "Senior Moderator", "value": "senior-moderator"},
					{ "name": "Super Moderator", "value": "super-moderator"},
					{ "name": "Ultra Moderator", "value": "ultra-moderator"},
					{ "name": "Administrator", "value": "administrator"}
				],
				users:[
					{id:1, name:"JustDucky", avatar: require("./../../assets/img/new-home/avatar01.jpg"), comments: 0, entries: 0, level: 4, registered: "2020-02-03", "last_online": "2021-02-03"},
					{id:2, name:"Studio", avatar: require("./../../assets/img/new-home/avatar02.jpg"), comments: 15, entries: 15, level: 1, registered: "2020-04-03", "last_online": "2021-05-03"},
					{id:3, name:"Eliza", avatar: require("./../../assets/img/new-home/avatar03.jpg"), comments: 12, entries: 43, level: 3, registered: "2020-06-13", "last_online": "2021-06-03"},
					{id:4, name:"Alex", avatar: require("./../../assets/img/new-home/avatar04.jpg"), comments: 0, entries: 25, level: 6, registered: "2020-05-25", "last_online": "2021-01-01"},
					{id:5, name:"Benjamin", avatar: require("./../../assets/img/new-home/avatar.jpg"), comments: 3, entries: 19, level: 7, registered: "2018-06-21", "last_online": "2021-06-11"},
					{id:6, name:"JustDucky", avatar: require("./../../assets/img/new-home/avatar01.jpg"), comments: 0, entries: 0, level: 4, registered: "2020-02-03", "last_online": "2021-02-03"},
					{id:7, name:"Studio", avatar: require("./../../assets/img/new-home/avatar02.jpg"), comments: 15, entries: 15, level: 1, registered: "2020-04-03", "last_online": "2021-05-03"},
					{id:8, name:"Eliza", avatar: require("./../../assets/img/new-home/avatar03.jpg"), comments: 12, entries: 43, level: 3, registered: "2020-06-13", "last_online": "2021-06-03"},
					{id:9, name:"Alex", avatar: require("./../../assets/img/new-home/avatar04.jpg"), comments: 0, entries: 25, level: 6, registered: "2020-05-25", "last_online": "2021-01-01"},
					{id:10, name:"Benjamin", avatar: require("./../../assets/img/new-home/avatar.jpg"), comments: 3, entries: 19, level: 7, registered: "2018-06-21", "last_online": "2021-06-11"},
					{id:11, name:"JustDucky", avatar: require("./../../assets/img/new-home/avatar01.jpg"), comments: 0, entries: 0, level: 4, registered: "2020-02-03", "last_online": "2021-02-03"},
					{id:12, name:"Studio", avatar: require("./../../assets/img/new-home/avatar02.jpg"), comments: 15, entries: 15, level: 1, registered: "2020-04-03", "last_online": "2021-05-03"},
					{id:13, name:"Eliza", avatar: require("./../../assets/img/new-home/avatar03.jpg"), comments: 12, entries: 43, level: 3, registered: "2020-06-13", "last_online": "2021-06-03"},
					{id:14, name:"Alex", avatar: require("./../../assets/img/new-home/avatar04.jpg"), comments: 0, entries: 25, level: 6, registered: "2020-05-25", "last_online": "2021-01-01"},
					{id:15, name:"Benjamin", avatar: require("./../../assets/img/new-home/avatar.jpg"), comments: 3, entries: 19, level: 7, registered: "2018-06-21", "last_online": "2021-06-11"}
				]
			}
		},
		computed: {
			currentRouteName() {
				return this.$route.name;
			}
		}
	}
</script>

<style lang='scss' scoped>
	@import '../../assets/scss/elementStyles.scss';
	@import '../../assets/scss/variables.scss';
	@import '../../assets/scss/idec.scss';

	.router-link-exact-active span:first-child {
		background-color: $color__green--primary;
	}

	.router-link-exact-active span:last-child {
		color: $color__green--primary;
	}

	.threads_main {
		display: flex;

		&__side_bar{
			width: 12rem;
			height: 0%;
			background: #fff;
			margin-right: 1rem;
			border-radius: 0.25rem;
			border: thin solid $color__gray--darker;
			padding: 0.5rem 0 1rem 1rem;
			position: sticky;
			top: 4.5rem;

			@at-root #{&}__title {
				color: $color__darkgray--darker;
				cursor: default;
				font-weight: 500;
				font-size: 1.125rem;
			}

			@at-root #{&}__menu_item {
				cursor: pointer;
				margin-top: 0.5rem;
				position: relative;
				display: grid;
				grid-template-columns: 0.75rem auto;
				grid-column-gap: 1rem;
				text-decoration: none;
				background-image: none;
				font-weight: normal;
				margin-left: 1.5rem;

				span{
					color: #fff;
				}

				@at-root #{&}__border {
					align-self: center;
					display: inline-block;
					height: 0.9rem;
					width: 0.9rem;
					border-radius: 0.5rem;
					margin-top: 0;
					background-color: $color__gray--darkest;
					transition: all 0.2s;
				}

				@at-root #{&}__text {
					filter: saturate(0.75), brightness(0.75);
				}


				@at-root #{&}--selected {
					font-weight: 600;
				}
			}
		}

		&__load_new{
			@extend .button;

			font-size: 1.25rem;
			margin: 0 0 1rem 0;
			background-color: $color__lightgray--primary;
			border-color: $color__gray--darker;
			width: 100%;
			font-weight: 300;
		}
	}

	.table{
		width: 100%;
		margin-bottom: 1rem;
		color: #212529;
		
		.table__heading {
			display: flex;
			min-height: 32px;
			align-items: center;
			font-size: 11px;
			margin-top: 1rem;
			margin-bottom: 1rem;
			font-weight: bold;
			color: #fff;
			border-bottom: 1px solid $color__green--darker;

			.table__column--width{

				&-fill{
					flex: 1;
				}
				&-small{
					width: 13%;
					min-width: 90px;
				}
				&-medium{
					width: 21%;
					min-width: 120px;
					display: flex;
					align-items: center;

					div{
						flex: 1;
					}
				}
			}
		}

		.table__row-outer-wrap{
			.table__row-inner-wrap{
				display: flex;
				align-items: center;
				line-height: 1.3em;
				color: #fff;
				padding: 10px 0;
				font-size: 14px;

				&:not(:last-child){
					border-bottom: 1px solid #d2d6e0;
				}

				.table__column--width{

					&-fill{
						flex: 1;
						margin-left: 15px;
					}
					&-small{
						width: 13%;
						min-width: 90px;

						svg{
							color: $color__green--darker;
						}
					}
					&-medium{
						width: 21%;
						min-width: 120px;
						display: flex;
						align-items: center;

						div{
							flex: 1;
						}
					}
				}
			}
		}
	}

	@media (max-width: $breakpoint--tablet) {
		.main_container{
			margin-top: 0!important;			
			.table{
				overflow-x: auto;
				
				.table__row-inner-wrap, .table__heading{
					min-width: 600px;
				}
			}
		}
	}
</style>
